<template>
  <hr class="mb-5 mt-6 styles" />
</template>

<script>
export default {
  name: "MiniDivider",
};
</script>

<style scoped>
.styles {
  border-top: 1px solid #8a8a8a;
  width: 18%;
}
</style>
